

import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  useGetShipmentDetailQuery,
  useUpdateShipmentMutation
} from "store/services/shipmentApi";

import ShipmentForm from "./ShipmentComponents/ShipmentForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";

const ShipmentEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment", path: "/app/crm/shipment/list" },
    { title: "Edit Shipment" },
  ];

  // RTK Query
  const { data: shipmentDetail, isLoading: loadingShipment, error,
  } = useGetShipmentDetailQuery(id);

  const [updateShipment, { isLoading: updatingShipment }
  ] = useUpdateShipmentMutation();

  //methods
  const handleUpdateShipment = async (data) => {

    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateShipment({ ..._payload },).unwrap();
      toast.success("Shipment successfully updated!");
      navigate(`/app/crm/shipment/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Shipment!"
      );
    }
  }

  useAppMeta("Edit Shipment");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingShipment || updatingShipment}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ShipmentForm
          isBusy={loadingShipment || updatingShipment}
          ShipmentDetail={shipmentDetail}
          onSubmit={handleUpdateShipment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );

}

export default ShipmentEditScreen;